// extracted by mini-css-extract-plugin
module.exports = {"accordion":"styles_accordion__PDtrF","contentWrapper":"styles_contentWrapper__0R9ab","content":"styles_content__739yy"};